import Constants from '@/Constants';
import { ProgramStatus } from '@/models/Program';
import { ApplicationState } from '@/store';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

const useStyles = makeStyles({
    root: { display: 'flex', flex: 1, padding: 15, width: 500, color: '#4c2b79', rail: { color: '#4c2b79', height: 8 } },
});

interface FilterProps {
    entityType: string;
    status: string;
    slideRange: number[];
    fakeSlideRange: number[];
    orderBy: string;
    isProgram?: boolean;
    mediaType: {
        VIDEO: boolean;
        AUDIO: boolean;
        EXTERNAL: boolean;
        HTML: boolean;
    };
    language: {
        en: boolean;
        pt: boolean;
    };
    typeOfTraining?: {
        courseOnLine: boolean;
        workshop: boolean;
    };
    visibility: {
        private: boolean;
        public: boolean;
    };
    setSlideRange: (prevState: any) => void;
    setFakeSlideRange: (prevState: any) => void;
    setOrderBy: (prevState: any) => void;
    setMediaType: (prevState: any) => void;
    setLanguage: (prevState: any) => void;
    setVisibility: (prevState: any) => void;
    setTypeOfTraining?: (prevState: any) => void;
}

export enum orderByFilterEnum {
    ALPHABETICAL = 'alphabetical',
    RATING = 'rating',
    CREATED_AT = 'createdAt',
}

const Filters = ({
    entityType,
    status,
    setSlideRange,
    setFakeSlideRange,
    setOrderBy,
    setMediaType,
    setLanguage,
    setVisibility,
    setTypeOfTraining,
    slideRange,
    fakeSlideRange,
    typeOfTraining,
    orderBy,
    mediaType,
    language,
    visibility,
    isProgram,
}: FilterProps) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    const classes = useStyles();

    const handleSlideChange = (event: any, newValue: number | number[]) => {
        setSlideRange(newValue as number[]);
    };

    const handleFakeSlideChange = (event: any, newValue: number | number[]) => {
        setFakeSlideRange(newValue as number[]);
    };

    const checkVisibilityActive = () => visibility.private || visibility.public;
    const checkTypeOfTrainingActive = () => typeOfTraining?.workshop || typeOfTraining?.courseOnLine;
    const checkMediaTypeActive = () => mediaType.AUDIO || mediaType.EXTERNAL || mediaType.HTML || mediaType.VIDEO;
    const checkSlideActive = () => slideRange[0] !== 0 || slideRange[1] !== 90;
    const checkLanguageActive = () => language.en || language.pt;

    const orderByItens: Record<string, string> = {
        alphabetical: strings.ALPHABETICAL_ORDER,
        rating: strings.TOP_RATED,
        createdAt: strings.NEWLY_CREATED,
    };

    const checkStatus = (programStatus: ProgramStatus[]) => {
        return programStatus.indexOf(status.toUpperCase() as ProgramStatus) !== -1;
    };

    return (
        <>
            <div className="filters">
                <span className="filter-text-left">{strings.FILTER_BY}:</span>
                <span className="filter-text-right">{strings.ORDER_BY}:</span>
            </div>
            <div className="filters">
                <div className="filters-one">
                    {checkStatus([Constants.programStatus.PUBLISHED]) && typeOfTraining && setTypeOfTraining && (
                        <div className="dropdown">
                            <button
                                className={`btn btn-primary btn-sm filter ${checkTypeOfTrainingActive() && 'is-active'}`}
                                data-toggle="dropdown"
                                type="button"
                            >
                                {strings.TYPE}
                            </button>

                            <div className="dropdown-menu dropdown-menu-right drop-three">
                                <div className="triangle-container t-three">
                                    <div className="dropdown-triangle" />
                                    <div className="dropdown-triangle-border" />
                                </div>
                                <div
                                    className="dropdown-content"
                                    onClick={() => setTypeOfTraining((prevState: any) => ({ ...prevState, courseOnLine: !prevState.courseOnLine }))}
                                    onKeyDown={() => {}}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i className="material-icons va-t m-right--xxs">
                                        {typeOfTraining.courseOnLine ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                    </i>
                                    <span>{strings.COURSE_ONLINE}</span>
                                </div>
                                <div
                                    className="dropdown-content"
                                    onClick={() => setTypeOfTraining((prevState: any) => ({ ...prevState, workshop: !prevState.workshop }))}
                                    onKeyDown={() => {}}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i className="material-icons va-t m-right--xxs">
                                        {typeOfTraining.workshop ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                    </i>
                                    <span>{strings.WORKSHOP}</span>
                                </div>
                            </div>
                        </div>
                    )}

                    {checkStatus([Constants.programStatus.PUBLISHED]) && !typeOfTraining && !setTypeOfTraining && (
                        <div className="dropdown">
                            {!isProgram && (
                                <button
                                    className={`btn btn-primary btn-sm filter ${checkVisibilityActive() && 'is-active'}`}
                                    data-toggle="dropdown"
                                    type="button"
                                >
                                    {strings.VISIBILITY}
                                </button>
                            )}

                            <div className="dropdown-menu dropdown-menu-right drop-three">
                                <div className="triangle-container t-three">
                                    <div className="dropdown-triangle" />
                                    <div className="dropdown-triangle-border" />
                                </div>
                                <div
                                    className="dropdown-content"
                                    onClick={() => setVisibility((prevState: any) => ({ ...prevState, private: !prevState.private }))}
                                    onKeyDown={() => {}}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i className="material-icons va-t m-right--xxs">
                                        {visibility.private ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                    </i>
                                    <span>{strings.PRIVATE}</span>
                                </div>
                                <div
                                    className="dropdown-content"
                                    onClick={() => setVisibility((prevState: any) => ({ ...prevState, public: !prevState.public }))}
                                    onKeyDown={() => {}}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i className="material-icons va-t m-right--xxs">
                                        {visibility.public ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                    </i>
                                    <span>{strings.PUBLIC}</span>
                                </div>
                            </div>
                        </div>
                    )}

                    {entityType === Constants.entityTypes.CONTENT && (
                        <div className="dropdown">
                            <button
                                className={`btn btn-primary btn-sm filter ${checkMediaTypeActive() && 'is-active'}`}
                                data-toggle="dropdown"
                                type="button"
                            >
                                {strings.MEDIA_TYPE}
                            </button>
                            <div className="dropdown-menu dropdown-menu-right drop-one">
                                <div className="triangle-container t-one">
                                    <div className="dropdown-triangle" />
                                    <div className="dropdown-triangle-border" />
                                </div>
                                <div
                                    className="dropdown-content"
                                    onClick={() => setMediaType((prevState: any) => ({ ...prevState, VIDEO: !prevState.VIDEO }))}
                                    onKeyDown={() => {}}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i className="material-icons va-t m-right--xxs">
                                        {mediaType.VIDEO ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                    </i>
                                    <span>{strings.VIDEO}</span>
                                </div>
                                <div
                                    className="dropdown-content"
                                    onClick={() => setMediaType((prevState: any) => ({ ...prevState, AUDIO: !prevState.AUDIO }))}
                                    onKeyDown={() => {}}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i className="material-icons va-t m-right--xxs">
                                        {mediaType.AUDIO ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                    </i>
                                    <span>{strings.AUDIO}</span>
                                </div>
                                <div
                                    className="dropdown-content"
                                    onClick={() => setMediaType((prevState: any) => ({ ...prevState, HTML: !prevState.HTML }))}
                                    onKeyDown={() => {}}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i className="material-icons va-t m-right--xxs">
                                        {mediaType.HTML ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                    </i>
                                    <span>{strings.ARTICLE}</span>
                                </div>
                                <div
                                    className="dropdown-content"
                                    onClick={() => setMediaType((prevState: any) => ({ ...prevState, EXTERNAL: !prevState.EXTERNAL }))}
                                    onKeyDown={() => {}}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <i className="material-icons va-t m-right--xxs">
                                        {mediaType.EXTERNAL ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                    </i>
                                    <span>{strings.LINK}</span>
                                </div>
                            </div>
                        </div>
                    )}
                    {entityType !== Constants.entityTypes.BUZZTEST &&
                        checkStatus([Constants.programStatus.PUBLISHED, Constants.programStatus.ARCHIVED]) && (
                            <div className="dropdown">
                                <button
                                    className={`btn btn-primary btn-sm filter ${checkSlideActive() && 'is-active'}`}
                                    data-toggle="dropdown"
                                    type="button"
                                >
                                    {strings.TIME}
                                </button>
                                <div className="dropdown-menu dropdown-menu-right drop-two">
                                    <div className="triangle-container t-two">
                                        <div className="dropdown-triangle" />
                                        <div className="dropdown-triangle-border" />
                                    </div>
                                    <div className="dropdown-content slider-content">
                                        <span>{strings.IN_MINUTES}:</span>
                                    </div>
                                    <div className="dropdown-content slider">
                                        <div className={classes.root}>
                                            <Slider
                                                aria-labelledby="discrete-slider-always"
                                                max={90}
                                                min={0}
                                                onChange={handleFakeSlideChange}
                                                onChangeCommitted={handleSlideChange}
                                                style={{ color: 'none' }}
                                                value={fakeSlideRange || [0, 90]}
                                                valueLabelDisplay="on"
                                                valueLabelFormat={(value) => (value === 90 ? value + '+' : value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    <div className="dropdown">
                        <button
                            className={`btn btn-primary btn-sm filter ${checkLanguageActive() && 'is-active'}`}
                            data-toggle="dropdown"
                            type="button"
                        >
                            {strings.LANGUAGE}
                        </button>
                        <div className="dropdown-menu dropdown-menu-right drop-three">
                            <div className="triangle-container t-three">
                                <div className="dropdown-triangle" />
                                <div className="dropdown-triangle-border" />
                            </div>
                            <div
                                className="dropdown-content"
                                onClick={() => setLanguage((prevState: any) => ({ ...prevState, pt: !prevState.pt }))}
                                onKeyDown={() => {}}
                                role="button"
                                tabIndex={0}
                            >
                                <i className="material-icons va-t m-right--xxs">
                                    {language.pt ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                </i>
                                <span>{strings.LANGUAGE_PT}</span>
                            </div>
                            <div
                                className="dropdown-content"
                                onClick={() => setLanguage((prevState: any) => ({ ...prevState, en: !prevState.en }))}
                                onKeyDown={() => {}}
                                role="button"
                                tabIndex={0}
                            >
                                <i className="material-icons va-t m-right--xxs">
                                    {language.en ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                </i>
                                <span>{strings.LANGUAGE_EN}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="dropdown">
                    <div className="filters-two">
                        <button className="btn btn-primary btn-sm order-by" data-toggle="dropdown" type="button">
                            <span className="align-middle">{orderByItens[orderBy]}</span>
                            <i className="material-icons-outlined align-middle down">arrow_drop_down</i>
                            <i className="material-icons-outlined align-middle up">arrow_drop_up</i>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right drop-order">
                            <div className="triangle-container t-order">
                                <div className="dropdown-triangle" />
                                <div className="dropdown-triangle-border" />
                            </div>
                            <div
                                className="dropdown-content"
                                onClick={() => setOrderBy(orderByFilterEnum.CREATED_AT)}
                                onKeyDown={() => {}}
                                role="button"
                                tabIndex={0}
                            >
                                <span>{strings.NEWLY_CREATED}</span>
                            </div>
                            <div
                                className="dropdown-content"
                                onClick={() => setOrderBy(orderByFilterEnum.ALPHABETICAL)}
                                onKeyDown={() => {}}
                                role="button"
                                tabIndex={0}
                            >
                                <span>{strings.ALPHABETICAL_ORDER}</span>
                            </div>
                            {!isProgram &&
                                entityType !== Constants.entityTypes.BUZZTEST &&
                                checkStatus([Constants.programStatus.PUBLISHED, Constants.programStatus.ARCHIVED]) && (
                                    <div
                                        className="dropdown-content"
                                        onClick={() => setOrderBy(orderByFilterEnum.RATING)}
                                        onKeyDown={() => {}}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        <span>{strings.TOP_RATED}</span>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Filters;
